module.exports = {"id":"dp2_5l3q4","text":"Digital Behaviour","instructions":"Respectful emoji use can improve tone clarity in digital communication.","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"2.5","questionType":"Scale","random":false,"options":[{"id":"dp2_5l3q4-a1","text":"Strongly disagree","score":2},{"id":"dp2_5l3q4-a2","text":"Disagree","score":2.4},{"id":"dp2_5l3q4-a3","text":"Neutral","score":3},{"id":"dp2_5l3q4-a4","text":"Agree","score":3.6},{"id":"dp2_5l3q4-a5","text":"Strongly agree","score":4}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat2.5/l3q4.json
// module id = 1075
// module chunks = 41